import { createAction } from "redux-actions";
import { takeLatest, put, call } from "redux-saga/effects";
import { userProfileApi } from "../api";
import { showToast } from "../../../utils/showToast";

const FETCH_PROFILE = "sagas/userProfile/FETCH_PROFILE";
const SUBMIT_PROFILE = "sagas/userProfile/SUBMIT_PROFILE";
export const FETCH_PROFILE_SUCCESS = "sagas/userProfile/FETCH_PROFILE_SUCCESS";
export const SUBMIT_PROFILE_FAILURE = "sagas/userProfile/SUBMIT_PROFILE_FAILURE";
export const SET_LOADING = "sagas/userProfile/SET_LOADING";
export const SET_SAVING = "sagas/userProfile/SET_SAVING";

export const actionCreators = {
  fetchProfile: createAction(FETCH_PROFILE),
  submitProfile: createAction(SUBMIT_PROFILE)
};

export default function* watchUserProfile() {
  yield takeLatestSafe(FETCH_PROFILE, fetchProfile);
  yield takeLatestSafe(SUBMIT_PROFILE, submitProfile);
}

function takeLatestSafe(action, saga) {
  return takeLatest(action, tryCatch(saga));
}

function tryCatch(saga) {
  return function* (args) {
    try {
      yield call(saga, args);
    } catch (error) {
      const message = error?.response?.data?.error || "Please try again.";
      yield put({ type: SUBMIT_PROFILE_FAILURE, payload: message });
    }
  };
}

function* fetchProfile() {
  yield put({ type: SET_LOADING, payload: true });

  try {
    const { data } = yield call(userProfileApi.getProfile);
    yield put({ type: FETCH_PROFILE_SUCCESS, payload: data });
  } finally {
    yield put({ type: SET_LOADING, payload: false });
  }
}

function* submitProfile({ payload: { first_name, last_name, separate_daily_email, showToggle } }) {
  yield put({ type: SET_SAVING, payload: true });

  const params = {
    first_name,
    last_name,
    ...(showToggle && { daily_email_settings: { separate_daily_email } })
  };

  try {
    const { data } = yield call(userProfileApi.update, params);
    yield put({ type: FETCH_PROFILE_SUCCESS, payload: data });

    showToast("Profile has been updated.", 2000, "success");
  } finally {
    yield put({ type: SET_SAVING, payload: false });
  }
}
